/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import * as tslib_1 from "tslib";
import { Base, runOn, delegateRemove, delegateCombine, markType } from "igniteui-react-core";
import { MinSummaryCalculator } from "igniteui-react-core";
import { MaxSummaryCalculator } from "igniteui-react-core";
import { SumSummaryCalculator } from "igniteui-react-core";
import { AverageSummaryCalculator } from "igniteui-react-core";
import { CountSummaryCalculator } from "igniteui-react-core";
import { FormatSummaryTextEventArgs } from "./FormatSummaryTextEventArgs";
/**
 * @hidden
 */
var ColumnSummaryDescription = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(ColumnSummaryDescription, _super);
    function ColumnSummaryDescription(a) {
        var _rest = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            _rest[_i - 1] = arguments[_i];
        }
        var _this = _super.call(this) || this;
        _this.l = false;
        _this.a = 0;
        _this.t = null;
        _this.g = 0;
        _this.c = null;
        _this.r = null;
        _this.s = null;
        _this.p = null;
        _this.m = 10;
        _this.formatText = null;
        _this.provideCalculator = null;
        _this.e = null;
        a = (a == void 0) ? 0 : a;
        switch (a) {
            case 0: break;
            case 1:
                {
                    var c = _rest[0];
                    _this.w = c;
                    _this.h = 4;
                }
                break;
            case 2:
                {
                    var c = _rest[0];
                    var d = _rest[1];
                    _this.w = c;
                    _this.h = d;
                }
                break;
        }
        return _this;
    }
    Object.defineProperty(ColumnSummaryDescription.prototype, "w", {
        get: function () {
            return this.t;
        },
        set: function (a) {
            this.t = a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ColumnSummaryDescription.prototype, "h", {
        get: function () {
            return this.g;
        },
        set: function (a) {
            this.g = a;
            switch (this.g) {
                case 0:
                    this.d = new MinSummaryCalculator();
                    break;
                case 1:
                    this.d = new MaxSummaryCalculator();
                    break;
                case 2:
                    this.d = new SumSummaryCalculator();
                    break;
                case 3:
                    this.d = new AverageSummaryCalculator();
                    break;
                case 4:
                    this.d = new CountSummaryCalculator();
                    break;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ColumnSummaryDescription.prototype, "d", {
        get: function () {
            return this.c;
        },
        set: function (a) {
            this.c = a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ColumnSummaryDescription.prototype, "u", {
        get: function () {
            return this.r;
        },
        set: function (a) {
            this.r = a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ColumnSummaryDescription.prototype, "v", {
        get: function () {
            return this.s;
        },
        set: function (a) {
            this.s = a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ColumnSummaryDescription.prototype, "q", {
        get: function () {
            return this.p;
        },
        set: function (a) {
            this.p = a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ColumnSummaryDescription.prototype, "o", {
        get: function () {
            return this.m;
        },
        set: function (a) {
            this.m = a;
        },
        enumerable: true,
        configurable: true
    });
    ColumnSummaryDescription.prototype.equals = function (a) {
        var b = a;
        if (b == null) {
            return _super.prototype.equals.call(this, a);
        }
        return b.w == this.w && b.h == this.h;
    };
    ColumnSummaryDescription.prototype.getHashCode = function () {
        return Base.getHashCodeStatic(this.w) * 17 + this.h;
    };
    ColumnSummaryDescription.prototype.i = function (a, b, c) {
        var _this = this;
        var d = ((function () {
            var $ret = new FormatSummaryTextEventArgs();
            $ret.c = _this.w;
            $ret.b = _this.v;
            $ret.a = a;
            $ret.d = b;
            $ret.e = c;
            return $ret;
        })());
        if (this.formatText != null) {
            this.formatText(this, d);
        }
        return d;
    };
    Object.defineProperty(ColumnSummaryDescription.prototype, "f", {
        get: function () {
            return this.e;
        },
        set: function (a) {
            var b = this.e;
            if (b != null) {
                b.provideCalculator = delegateRemove(b.provideCalculator, runOn(this, this.x));
            }
            this.e = a;
            if (this.e != null) {
                var c = this.e;
                c.provideCalculator = delegateCombine(c.provideCalculator, runOn(this, this.x));
            }
        },
        enumerable: true,
        configurable: true
    });
    ColumnSummaryDescription.prototype.x = function (a, b) {
        if (this.provideCalculator != null) {
            this.provideCalculator(this, b);
            this.d = b.a;
        }
    };
    ColumnSummaryDescription.$t = markType(ColumnSummaryDescription, 'ColumnSummaryDescription');
    return ColumnSummaryDescription;
}(Base));
export { ColumnSummaryDescription };
//# sourceMappingURL=ColumnSummaryDescription.js.map
